// Which ALR table a row of the merged overview came from. Mirrors AlrInvoiceKind server-side; kept
// out of databaseModels.ts because it is a projection-time discriminator, not a stored column.
export enum AlrInvoiceKind {
    Subscription = 0,
    Custom = 1,
}

const CONTROLLER_BY_KIND: Record<AlrInvoiceKind, string> = {
    [AlrInvoiceKind.Subscription]: 'FreelancerSubscriptionInvoice',
    [AlrInvoiceKind.Custom]: 'FreelancerCustomInvoice',
};

// The overview merges two tables, but detail and download stay with the controller of the table the
// row came from - both in Admin and for the freelancer. Falls back to the subscription controller so
// a row without a kind (an older cached response) still links somewhere.
export function alrInvoiceControllerFor(item: any): string {
    return CONTROLLER_BY_KIND[item.kind as AlrInvoiceKind] ?? CONTROLLER_BY_KIND[AlrInvoiceKind.Subscription];
}
